import React from 'react';
import { motion } from 'framer-motion';
export const Privacy = () => {
  return <main className="pt-32 pb-24 bg-brand-warm-white min-h-screen" data-id="element-474" data-mp="2wjx7lyrl3u7y">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto px-6" data-id="element-475" data-mp="2whkgow3um9ir">
        <div className="mb-16" data-id="element-476" data-mp="3k884kqu5t9qy">
          <span className="text-brand-gold font-bold tracking-widest uppercase text-sm mb-4 block" data-id="element-477" data-mp="3kbce83qe8xp0">
            Legal
          </span>
          <h1 className="text-4xl md:text-5xl font-display text-brand-navy mb-6" data-id="element-478" data-mp="3u75n9d4wm921">
            Privacy Policy
          </h1>
          <p className="text-brand-charcoal/60" data-id="element-479" data-mp="3p9dw4lc32qyw">Last updated: July 14, 2026</p>
        </div>

        <div className="space-y-12 text-brand-charcoal/80 leading-relaxed bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-brand-navy/5" data-id="element-480" data-mp="1zsmn3h7u4hn6">
          <section data-id="element-481" data-mp="1uwecmh4l1cmc">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-482" data-mp="h263g7mb5ha2">
              1. Introduction
            </h2>
            <p className="mb-4" data-id="element-483" data-mp="l39hcoksp38n">
              Consilium Advisory ("we," "our," or "us") respects your privacy
              and is committed to protecting your personal data. This privacy
              policy will inform you as to how we look after your personal data
              when you visit our website and tell you about your privacy rights
              and how the law protects you.
            </p>
          </section>

          <section data-id="element-484" data-mp="14qffihtpyqo0">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-485" data-mp="14pxfrb7ulubc">
              2. The Data We Collect
            </h2>
            <p className="mb-4" data-id="element-486" data-mp="1dsgbzch4p8om">
              We may collect, use, store and transfer different kinds of
              personal data about you which we have grouped together as follows:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-brand-charcoal/70" data-id="element-487" data-mp="3fjtdrsnsv0gg">
              <li data-id="element-488" data-mp="3flw82ovzjfqz">
                <strong data-id="element-489" data-mp="mpbbav2gzlps">Identity Data</strong> includes first name, last name,
                username or similar identifier.
              </li>
              <li data-id="element-490" data-mp="hrjmi9x4gfpt">
                <strong data-id="element-491" data-mp="hs2sqtdetfo0">Contact Data</strong> includes email address and
                telephone numbers.
              </li>
              <li data-id="element-492" data-mp="qqwnee76jvyx">
                <strong data-id="element-493" data-mp="qqev1snn21wa">Technical Data</strong> includes internet protocol (IP)
                address, your login data, browser type and version, time zone
                setting and location.
              </li>
              <li data-id="element-494" data-mp="10pvxm17lfzo1">
                <strong data-id="element-495" data-mp="10ob3udt3skr8">Usage Data</strong> includes information about how you
                use our website, products and services.
              </li>
            </ul>
          </section>

          <section data-id="element-496" data-mp="1afypfy2zb7ks">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-497" data-mp="1affex2fnrlgs">
              3. How We Use Your Data
            </h2>
            <p className="mb-4" data-id="element-498" data-mp="1occ46zg4ouvk">
              We will only use your personal data when the law allows us to.
              Most commonly, we will use your personal data in the following
              circumstances:
            </p>
            <ul className="list-disc pl-6 space-y-2 text-brand-charcoal/70" data-id="element-499" data-mp="28105i6qh1wws">
              <li data-id="element-500" data-mp="1t37rxk4hjil8">
                Where we need to perform the contract we are about to enter into
                or have entered into with you.
              </li>
              <li data-id="element-501" data-mp="1y0g4n56v6uf3">
                Where it is necessary for our legitimate interests (or those of
                a third party) and your interests and fundamental rights do not
                override those interests.
              </li>
              <li data-id="element-502" data-mp="1acyjhsi3uul3">Where we need to comply with a legal obligation.</li>
            </ul>
          </section>

          <section data-id="element-503" data-mp="1fb9u45g8594d">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-504" data-mp="1fcumppizahzl">
              4. Data Security
            </h2>
            <p className="mb-4" data-id="element-505" data-mp="11cjv2k9ugzdd">
              We have put in place appropriate security measures to prevent your
              personal data from being accidentally lost, used or accessed in an
              unauthorized way, altered or disclosed. In addition, we limit
              access to your personal data to those employees, agents,
              contractors and other third parties who have a business need to
              know.
            </p>
          </section>

          <section data-id="element-506" data-mp="jkhm5rz0xxfo">
            <h2 className="text-2xl font-display text-brand-navy mb-4" data-id="element-507" data-mp="jkznh30jn1ug">
              5. Contact Us
            </h2>
            <p className="mb-4" data-id="element-508" data-mp="fhupndreroc5">
              If you have any questions about this privacy policy or our privacy
              practices, please contact us at:
            </p>
            <p className="font-medium text-brand-navy" data-id="element-509" data-mp="5m9rxrtdha87">
              Emmanuel@consiliumadvisory.com
              <br data-id="element-510" data-mp="o7zwhdyy0kl" />
              240-882-3949
            </p>
          </section>
        </div>
      </motion.div>
    </main>;
};